module.exports = __webpack_public_path__ + "static/media/ic_award_add.96fe85cc.svg";